import { jsx, jsxs } from "react/jsx-runtime";
function ErrorIcon() {
    return /*#__PURE__*/ jsxs("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "1em",
        height: "1em",
        viewBox: "0 0 64 64",
        fill: "none",
        children: [
            /*#__PURE__*/ jsx("path", {
                d: "M32 58.6667C46.7276 58.6667 58.6667 46.7276 58.6667 32C58.6667 17.2724 46.7276 5.33337 32 5.33337C17.2724 5.33337 5.33334 17.2724 5.33334 32C5.33334 46.7276 17.2724 58.6667 32 58.6667Z",
                fill: "currentColor",
                stroke: "currentColor",
                strokeWidth: "5.33333",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M38.9998 25L24.9998 39",
                stroke: "white",
                strokeWidth: "4.26667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            }),
            /*#__PURE__*/ jsx("path", {
                d: "M25.0002 25L39.0002 39",
                stroke: "white",
                strokeWidth: "4.26667",
                strokeLinecap: "round",
                strokeLinejoin: "round"
            })
        ]
    });
}
export { ErrorIcon as default };
